<template>
  <div class="web_menu">
    <div class="menu_content">
      <template v-for="(menu, i) in menuList">
        <span :key="i + 'line'" class="line">|</span>
        <span :key="i + 'menu'" class="menu_item"
              :class="{'is-active': activePath.menuId === menu.id || activePath.enMenuId === menu.id}"
              @click="intoPage(menu)">{{menu.name}}</span>
      </template>
      <span class="line">|</span>
    </div>
  </div>
</template>

<script>
import { getCookie, clearLoginInfo } from '../../utils/';
import SubMenu from './sub-menu'

export default {
  components: {
    SubMenu
  },
  data () {
    return {
      activePath: {},
      // menuList: [
      //   {id: 1, name: '首页', jumpUrl: '/home', sort: 1},
      //   {id: 2, name: '关于我们', jumpUrl: '/about', sort: 4},
      //   {id: 3, name: '联盟动态', jumpUrl: '/dynamics', sort: 5},
      //   {id: 4, name: '综合服务', jumpUrl: '/services', sort: 6},
      //   {id: 5, name: '互动交流', jumpUrl: '/interaction', sort: 7},
      // ]
    }
  },
  computed: {
    isLogin: {
      get () {
        return this.$store.state.user.isLogin
      },
    },
    realName () {
      return this.$store.state.user.realName
    },
    menuList: {
      get () {
        return this.$store.state.common.menuList
      },
      set (val) {
        this.$store.commit('common/updateMenuList', val)
      }
    },
    localeLang: {
      get () { return this.$store.state.common.localeLang },
    }
  },
  watch: {
    $route: 'routeHandle',
    localeLang (val) {
      this.getMenuList()
    }
  },
  created () {
    this.getMenuList()
    this.routeHandle(this.$route)
  },
  methods: {
    getMenuList () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/nav/list'),
        method: 'post',
        data: {
          orderByAsc: 'seqNum',
          isPage: false,
          data: {
            lang: this.localeLang
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          let data = res.data.result.list || []
          if (data.length) {
            this.menuList = data
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    intoPage (menu) {
      this.activePath.menuId = menu.id
      this.$router.push({ path: menu.jumpUrl })
    },
    routeHandle (route) {
      this.activePath = {...route.meta}
    },
  }
}
</script>

<style lang="scss">
.web_menu {
  position: absolute;
  background: rgba($color: #265ba9, $alpha: 0.8);
  bottom: 0;
  width: 100%;
  .menu_content{
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    letter-spacing: 2px;
    line-height: 50px;
  }
  .line{
    color: #7a99c6;
  }
  .menu_item{
    cursor: pointer;
    color: #fff;
    padding: 0 10px;
  }
  .is-active{
    border-bottom: 2px solid #fff;
    box-sizing: border-box;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/menu.vue